import React, { useState } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { withTranslate } from 'react-redux-multilingual'
import { compose } from 'redux'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Fab from '@material-ui/core/Fab'
import PhotoCamera from '@material-ui/icons/PhotoCamera'
import FileInputComponent from 'react-file-input-previews-base64'
import Profile from '../../assets/profile.png'
import TaxId from '../../assets/taxid.png'

// Redimensiona uma imagem base64 a um max-width preservando aspect ratio.
// Retorna outra string base64 (data URL JPEG).
function resizePhotoBase64(base64, maxWidth) {
  return new Promise((resolve) => {
    const image = new Image()
    image.onload = () => {
      const ratio = image.width > maxWidth ? maxWidth / image.width : 1
      const canvas = document.createElement('canvas')
      canvas.width = image.width * ratio
      canvas.height = image.height * ratio
      canvas.getContext('2d').drawImage(image, 0, 0, canvas.width, canvas.height)
      resolve(canvas.toDataURL('image/jpeg', 1))
    }
    image.src = base64
  })
}

const TYPE_CONFIG = {
  self: {
    defaultImage: Profile,
    maxWidth: 200,
    fieldName: 'photo',
    altText: 'profilePhoto',
    textKey: 'uploadPhotoText',
    helperTextKey: 'uploadPhotoHelperText'
  },
  document: {
    defaultImage: TaxId,
    maxWidth: 450,
    fieldName: 'document_photo',
    altText: 'documentPhoto',
    textKey: 'uploadDocumentPhotoText',
    helperTextKey: 'uploadDocumentPhotoHelperText'
  }
}

function PhotoUploadStep({ classes, translate, type, setCheckinField, onUploaded }) {
  const config = TYPE_CONFIG[type]
  const [imgUrl, setImgUrl] = useState(config.defaultImage)

  const handleFile = (files) => {
    resizePhotoBase64(files[0].base64, config.maxWidth).then((url) => {
      setCheckinField(config.fieldName, url.split(';base64,')[1])
      setImgUrl(url)
      onUploaded()
    })
  }

  return (
    <Grid container>
      <Grid item xs={12} className={classes.image}>
        <img
          src={imgUrl}
          alt={config.altText}
          style={{
            width: 200,
            height: 'auto',
            resizeMode: 'cover',
            borderRadius: '50%'
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography className={classes.title} component="h2">
          {translate(config.textKey)}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography className={classes.text} component="p">
          {translate(config.helperTextKey)}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <FileInputComponent
          labelText=""
          parentStyle={{ textAlign: 'center' }}
          imagePreview={false}
          labelStyle={{ fontSize: 14 }}
          multiple={true}
          imageStyle={{ borderRadius: '50%' }}
          callbackFunction={handleFile}
          accept="image/*"
          buttonComponent={
            <Fab color="primary" aria-label="Add" className={classes.fab}>
              <PhotoCamera />
            </Fab>
          }
        />
      </Grid>
    </Grid>
  )
}

const styles = (theme) => ({
  image: {
    marginTop: 10,
    textAlign: 'center',
    borderRadius: '50%'
  },
  fab: {
    margin: theme.spacing(1)
  },
  text: {
    color: '#757575',
    textAlign: 'center'
  },
  title: {
    color: '#000',
    textAlign: 'center',
    fontSize: 24
  }
})

export default compose(withStyles(styles))(withTranslate(PhotoUploadStep))
